import { supabase } from "@/lib/supabase/client";
import { authCallbackUrl } from "@/constants/routes";

export const signInWithEmail = ({ email, password }) =>
  supabase.auth.signInWithPassword({ email: email.trim(), password });

export const signUpWithEmail = ({ fullName, email, password }) =>
  supabase.auth.signUp({
    email: email.trim(),
    password,
    options: { data: { full_name: fullName.trim() }, emailRedirectTo: authCallbackUrl() },
  });

export const resendConfirmation = (email) =>
  supabase.auth.resend({ type: "signup", email: email.trim(), options: { emailRedirectTo: authCallbackUrl() } });
